import { syncFarms } from './others/syncFarms'
import { syncZones } from './others/syncZones'
import { syncLots } from './others/syncLots'
import { syncAnimals } from './others/syncAnimals'
import { syncEvents } from './others/syncEvents'

export async function syncAll() {
	await syncFarms()
	await syncZones()
	await syncLots()
	await syncAnimals()
	await syncEvents()
}